import React, {Component} from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"
import classes from "./Home.module.scss"
import Countdown from 'react-countdown'
import heroImage from "../../assets/images/drawdown2026.png"
import ecfLogo2 from "../../assets/images/ecfoundation1.png"
import ecfVideo from "../../assets/images/checkPresentation.mp4"
// import { Message } from "../../components/Shared/Announcement"
// https://www.timestamp-converter.com/

// const plungeTix = "https://www.eventbrite.com/e/2026-pelican-plunge-tickets-1975357441282?utm-campaign=social&utm-content=attendeeshare&utm-medium=discovery&utm-term=listing&utm-source=cp&aff=ebdsshcopyurl"

class Home extends Component {
  render() {
    // <Message addClass="show940" />
    return (
      <div className={classes.HomePage}>
        <Helmet>
          <title>Supporting Youth in Northwest Florida | The Emerald Coast Foundation</title>
          <meta name="description" content="The Emerald Coast Foundation's purpose is to support children's charities and youth organizations in Okaloosa County." />
        </Helmet>

        <div className={[classes.CountdownFlex, classes.vdraw].join(' ')}>
          <div className={[classes.sectionWrap, classes.insideN].join(' ')}>
            <div className={classes.flexGroup}>
              <div className={classes.titleGroup}>
                <h2><span>The Great</span><br/> Emerald Coast Foundation</h2>
                <h1 className={classes.fun}>Drawdown</h1>
                <h3 className={classes.mobDate}>{this.props.dates}</h3>
              </div>

              <div className={classes.counterGroup}>
                <div className={[classes.clockWrap].join(' ')}>
                  <h3 className={classes.date}>{this.props.dates}</h3>
                  <div className={classes.csClock}>
                    <Countdown date={'2026-11-12T05:00:00.000Z'} />
                    <div className={classes.csId}>
                      <p className={classes.timeRef}>D<span>ays</span></p>
                      <p className={classes.timeRef}>H<span>ours</span></p>
                      <p className={classes.timeRef}>M<span>in</span></p>
                      <p className={classes.timeRef}>S<span>ec</span></p>
                    </div>
                  </div>
                  <div className={classes.mobBtn}>
                  <Link to="/drawdown" className={[classes.ecLink, classes.l1].join(' ')}>Learn More</Link>
                </div>
                </div>
              </div>

              <div className={classes.btnGroup}>
                <Link to="/drawdown" className={[classes.ecLink, classes.l1].join(' ')}>Learn More</Link>
              </div>
            </div>
          </div>

          <div className={[classes.imageGroup, classes.insideXl].join(' ')}>
            <Link to="/drawdown">
              <img src={heroImage} alt="Enter the Emerald Coast Drawdown to win $10,000" className={[classes.imgResponsive].join(' ')} />
            </Link>
          </div>
        </div>

        <div className={[classes.welcomeBox].join(' ')}>
          <div className={classes.top}>
            <div className={[classes.topWrap, classes.inside10].join(' ')}>
              <h3 className={[classes.textGroup, classes.hdText].join(' ')}> The Emerald Coast Drawdown</h3>
              <h4 className={[classes.textGroup, classes.subText].join(' ')}>1 in 500 Chance to win $10,000</h4>
              <p className={[classes.textGroup, classes.ptext].join(' ')}>Will you take home the {this.props.year} cash prize? </p>
            </div>
          </div>
            
          <div className={[classes.textGroup, classes.bodyText].join(' ')}>
            <div className={[classes.sectionWrap, classes.flexGroup, classes.inside10].join(' ')}>
              <div className={classes.g1}>
                <p className={classes.lgp}>
                  The Emerald Coast Drawdown is back — and this year, the stakes are higher than ever. With 
                  only <span>500 tickets</span> available, <span> every ticket is a winner.</span> Don't miss your shot. 
                </p>
                <p className={classes.bold}>
                  Each ticket includes a one-night stay at the IP 
                  Casino Resort &amp; Spa in Biloxi, MS — plus your chance to win up to $10,000 in cash.
                </p>
                <p>Tickets are drawn one at a time. The later your number is drawn, the bigger the prize. It's that simple.</p>
              </div>

              <div className={classes.g2}>
                <p className={classes.lgp}>WHY EVERY TICKET MATTERS</p>
                <p>This isn't just a chance to win — it's a chance to give. Proceeds from the 
                  Emerald Coast Drawdown directly benefit the children's charities of Northwest Florida 
                  through the Emerald Coast Foundation. Your $100 ticket is an overnight getaway, a shot at $10,000, 
                  and an investment in the kids of our community.
                </p>
                <p className={classes.bold}>Only 500 tickets will be sold. Once they're gone, they're gone.</p>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.foundation}>
          <div className={[classes.sectionWrap, classes.medDef].join(' ')}>
            <div className={classes.motto}>
              <img src={ecfLogo2} alt="Emerald Coast Foundation Logo" className={[classes.imgResponsive].join(' ')} />
              <p>To provide support, resources, and funding to local children's charities, in order that they may achieve all their goals.</p>
            </div>

            <div className={classes.ecBody}>
              <div className={classes.tbHalf}>
                <div className={classes.textBox}>
                  <p className={classes.h3}>A little about us...</p>
                  <p>  
                    The strength of the Emerald Coast Foundation is its ability to achieve its mission: ECF is committed to “Investing in Youth” in Northwest Florida.
                    This capacity is encapsulated in a number of fund raising activities that take place throughout the calendar year. The largest is the Children's Charity Poker Run, held in August each year.
                    <br/>
                    The Emerald Coast Foundation is the only not-for-profit organization that puts forth such effort, for the sole purpose of expanding its charitable reward and helping our most precious resource: the children of our community. To date, we have raised over 2 million dollars for our causes.
                  </p>
                  <div className={classes.clearfix}/>
                  <Link to="/ec-foundation" className={classes.ecLinkSm}>Learn More</Link>
                </div>
              </div>

              <div className={[classes.videoBox, classes.ecfVideo].join(' ')}>
                <video
                  src={ecfVideo}
                  frameBorder="0"
                  title="Emerald Coast Foundation presents donation"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  data-uk-responsive
                  controls={true}
                  uk-video="automute: true; autoplay: inview;"
                  className={classes.FullWidth}
                  loop={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Home